import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "../css/blog.css";

const Blogs = () => {
    const [selectedBlog, setSelectedBlog] = useState(null);
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0)
    })

    const blogs = [
        {
            id: 1,
            title: "10 Essential Tips for Smart Online Shopping",
            description:
                "Explore effective ways to save money and make the most of your online shopping journey.",
            image: "/images/banners/blog1.jpg",
            content: `Online shopping has become an integral part of daily life. 
From the convenience it offers to the wide variety of products available, shopping online has numerous advantages. 
However, without proper guidance, shoppers may overspend or purchase items that don't meet expectations. 
First, always compare prices across different platforms to secure the best deal. Use price comparison tools or browser extensions that notify you of discounts. 
Second, read product reviews carefully. Focus on verified purchases and detailed feedback instead of generic comments. 
Third, review the seller’s return and refund policies. Make sure you can easily return items if they are defective or unsatisfactory. 
Fourth, subscribe to newsletters for exclusive deals, using a dedicated email to avoid spam. 
Fifth, use secure payment options such as credit cards or PayPal, which provide buyer protection. 
Sixth, stay wary of deals that seem too good to be true—they often are. 
Seventh, track your spending and set monthly budgets to prevent impulsive purchases. 
Eighth, check shipping costs and delivery times before finalizing your order. 
Ninth, take advantage of loyalty programs and cashback offers. 
Finally, protect your personal information and avoid sharing sensitive details on unverified websites. 
Following these practices will make your online shopping safer, smarter, and more rewarding, ensuring you get the best value for your money.`
        },
        {
            id: 2,
            title: "Choosing the Right Home Appliances",
            description:
                "Tips to help you select appliances that match your lifestyle, budget, and home requirements.",
            image: "/images/banners/blog2.jpg",
            content: `Selecting home appliances can feel overwhelming due to the wide variety available. 
Start by identifying your needs: consider household size, usage frequency, and specific requirements. 
For kitchen appliances, prioritize energy efficiency and durability. Look for products with energy ratings and warranties. 
Research reliable brands with positive customer feedback. Consider space and design: appliances should fit your kitchen layout and match your home's aesthetics. 
Factor in long-term costs including maintenance and electricity usage. Read product manuals and specifications to ensure compatibility with your home environment. 
Consider multi-functional appliances, such as combination ovens or washer-dryer units, to save space and money. 
Check for safety features, especially if children or pets are present. 
Compare prices across retailers for the best deal, and look for seasonal discounts or cashback offers. 
Consult professionals if needed, particularly for complex installations like refrigerators or air conditioners. 
Finally, register your appliances and keep receipts to claim warranties when necessary. 
Making informed choices ensures efficient, comfortable, and long-lasting home appliances.`
        },
        {
            id: 3,
            title: "Personal Care Tips for a Healthy Lifestyle",
            description:
                "Practical guidance for skincare, hair care, wellness, and maintaining overall health every day.",
            image: "/images/banners/blog3.jpg",
            content: `Maintaining your health and wellbeing is essential for a long and active life. 
Start with a balanced diet full of fruits, vegetables, proteins, and healthy fats to support overall wellness. 
Stay hydrated by drinking plenty of water daily, which benefits your skin and metabolism. 
Establish a regular skincare routine including cleansing, moisturizing, and sun protection. 
Select hair care products appropriate for your hair type and avoid excessive heat to prevent damage. 
Engage in daily exercise for at least 30 minutes to strengthen muscles, improve heart health, and boost mental clarity. 
Ensure adequate sleep of 7-8 hours per night to rejuvenate body and mind. 
Manage stress through meditation, mindfulness, or hobbies to support emotional wellbeing. 
Limit processed foods, sugary drinks, and alcohol to maintain energy and immunity. 
Schedule regular medical checkups and preventive screenings to catch potential health issues early. 
Incorporate wellness habits such as hand hygiene, dental care, and maintaining good posture to reduce long-term risks. 
By following these personal care strategies, you can enhance your physical, mental, and emotional health for a more balanced and fulfilling life.`
        }
    ];


    const handleReadMore = (blog) => {
        setSelectedBlog(blog);
        setShowModal(true);
    };

    const closeModal = () => {
        setSelectedBlog(null);
        setShowModal(false);
    };

    return (
        <section className="container mb-5">
            <nav aria-label="breadcrumb" className="mt-4 mb-5">
                <ol className="breadcrumb">
                    {/* Home Link */}
                    <li className="breadcrumb-item">
                        <Link to="/" className="text-dark text-decoration-none">
                            <i className="fas fa-home me-2"></i> Home
                        </Link>
                    </li>
                    <li className="breadcrumb-item">
                        <i className="fa-regular fa-folder me-2"></i> Blogs
                    </li>
                </ol>
            </nav>
            <h2 className="fw-bold text-dark mb-4">Latest Blogs</h2>
            <div className="blog-cards-section">
                <div className="row">
                    {blogs.map((blog) => (
                        <div key={blog.id} className="col-md-4 mb-4">
                            <div className="card h-100 shadow-sm">
                                <img
                                    src={blog.image}
                                    className="card-img-top"
                                    alt={blog.title}
                                    style={{ height: "250px", objectFit: "cover" }}
                                />
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title">{blog.title}</h5>
                                    <p className="card-text">{blog.description}</p>
                                    <button
                                        onClick={() => handleReadMore(blog)}
                                        className="mt-auto btn btn-dark"
                                    >
                                        Read More
                                    </button>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>

            {/* Modal */}
            {selectedBlog && (
                <div className="modal-overlay" onClick={closeModal}>
                    <div
                        className="modal-content"
                        style={{ backgroundImage: `url(${selectedBlog.image})` }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        <button className="modal-close" onClick={closeModal}>
                            &times;
                        </button>
                        <div className="modal-text">
                            <h2>{selectedBlog.title}</h2>
                            <p>{selectedBlog.content}</p>
                        </div>
                    </div>
                </div>
            )}
        </section>
    );
};

export default Blogs;
